import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type TrackedPdfSplitJob = {
  label: string;
};

export type PdfSplitJobsState = {
  jobs: Record<string, TrackedPdfSplitJob>;
};

const initialState: PdfSplitJobsState = {
  jobs: {},
};

const pdfSplitJobsSlice = createSlice({
  name: "pdfSplitJobs",
  initialState,
  reducers: {
    trackPdfSplitJob: (
      state,
      action: PayloadAction<{ jobId: string; label: string }>,
    ) => {
      state.jobs[action.payload.jobId] = { label: action.payload.label };
    },
    removePdfSplitJob: (state, action: PayloadAction<{ jobId: string }>) => {
      delete state.jobs[action.payload.jobId];
    },
    hydratePdfSplitJobs: (
      state,
      action: PayloadAction<PdfSplitJobsState["jobs"]>,
    ) => {
      state.jobs = action.payload ?? {};
    },
    resetPdfSplitJobs: (state) => {
      state.jobs = {};
    },
  },
});

export const {
  trackPdfSplitJob,
  removePdfSplitJob,
  hydratePdfSplitJobs,
  resetPdfSplitJobs,
} = pdfSplitJobsSlice.actions;
export default pdfSplitJobsSlice.reducer;
